import React, { useState, useRef, useEffect, useContext } from "react";
import {
  IconButton,
  Badge,
  Popper,
  Paper,
  List,
  ListItem,
  ListItemText,
  Divider,
  ClickAwayListener,
  Fade,
  Typography,
} from "@mui/material";
import Notificacion from "../../assets/img/svg/notificacion.svg";
import { UserContext } from "../../context/userContext/UserContext";
import { ReactComponent as CompletadoIcon } from "../../assets/img/svg/notifications/completado.svg";
import { ReactComponent as PendienteIcon } from "../../assets/img/svg/notifications/pendiente.svg";
import { ReactComponent as ErrorIcon } from "../../assets/img/svg/notifications/error.svg";
import CustomButton from "../../ui/button/Button";
import { getNotifications } from "../../components/functions/Notifications";
import { parseDateWithMonth } from "../../utils/notificationsHelpers";

import { useNavigate } from "react-router-dom";
const exampleNotifications = [
  {
    id: 1,
    message:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    date: "Hace 40 minutos",
    icon: <CompletadoIcon width={16} />,
  },
  {
    id: 2,
    message:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    date: "Hace 40 minutos",
    icon: <PendienteIcon width={16} />,
  },
  {
    id: 3,
    message:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    date: "Hace 40 minutos",
    icon: <ErrorIcon width={16} />,
  },
];

export default function NotificationsDropdown({ API_URL }) {
  const { user } = useContext(UserContext);
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);

  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    const fetchNotifications = async () => {
      const exampleNotifications = await getNotifications(API_URL, user.id);
      exampleNotifications.forEach((item) => {
        item.icon =
          item.estatus === "completado" ? (
            <CompletadoIcon width={16} />
          ) : item.estatus === "pendiente" ? (
            <PendienteIcon width={16} />
          ) : (
            <ErrorIcon width={16} />
          );
        const { date, time } = parseDateWithMonth(item.created_at);
        item.date = `${time} - ${date}`;
        item.message = item.titulo;
      });
      setNotifications(exampleNotifications);
    };
    if (user) {
      fetchNotifications();
    }
  }, [user]);

  const togglePopper = () => {
    setOpen((prev) => !prev);
  };

  const closePopper = () => {
    setOpen(false);
  };

  return (
    <>
      <IconButton
        title="Notificaciones Internas"
        color="inherit"
        ref={anchorRef}
        onClick={togglePopper}
      >
        <Badge
          badgeContent={notifications.filter((item) => !item.leido).length}
          color="error"
          slotProps={{
            badge: {
              sx: {
                fontSize: "0.8rem",
                minWidth: 16,
                height: 16,
                padding: "0 5px",
              },
            },
          }}
        >
          <img style={{ cursor: "pointer" }} src={Notificacion} alt="" />
        </Badge>
      </IconButton>

      <Popper
        open={open}
        anchorEl={anchorRef.current}
        placement="bottom"
        transition
        sx={{
          zIndex: 1300,
        }}
      >
        {({ TransitionProps }) => (
          <ClickAwayListener onClickAway={closePopper}>
            <Fade {...TransitionProps} timeout={250}>
              <Paper
                elevation={4}
                sx={{
                  width: 360,
                  maxHeight: 400,
                  overflowY: "auto",
                  padding: 1,
                  backgroundColor: "#fff",
                  zIndex: 1300,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: 8,
                    color: "#223D51",
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: "0.9rem",
                      color: "#223d51",
                      fontWeight: 500,
                    }}
                  >
                    Notificaciones
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: "0.9rem",
                      color: "#223d51",
                      fontWeight: 600,
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      navigate("/notificaciones");
                      closePopper();
                    }}
                  >
                    Ver todo ({notifications.length})
                  </Typography>
                </div>
                <Divider />

                <List disablePadding>
                  {notifications.slice(0, 5).map((notification, index) => (
                    <React.Fragment key={notification.id}>
                      <ListItem
                        alignItems="flex-start"
                        onClick={closePopper}
                        sx={{
                          "&:hover": { backgroundColor: "#f0f0f0" },
                          cursor: "pointer",
                          paddingY: 0.5,
                          paddingX: 1.5,
                          minHeight: "36px",
                        }}
                      >
                        <ListItemText
                          primary={
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 8,
                                justifyContent: "space-between",
                              }}
                            >
                              {notification.icon}
                              <Typography
                                variant="body2"
                                sx={{
                                  fontSize: "0.8rem",
                                  flex: 1,
                                  marginRight: 2,
                                  fontWeight: notification.leido
                                    ? "normal"
                                    : "bold",
                                }}
                                align="left"
                                color="#223D51"
                              >
                                {notification.message}
                                <br />{" "}
                                <span style={{ fontSize: "0.7rem" }}>
                                  {notification.date}
                                </span>
                              </Typography>
                              <CustomButton
                                text={"Ver"}
                                color={"#223D51"}
                                background={"#FFFFFF"}
                                fontStyle={"normal"}
                                fontWeight={500}
                                fontSize={"14px"}
                                width={"50px"}
                                height={"24px"}
                                type={"button"}
                                border={
                                  "1px solid hsla(206, 40.90%, 22.50%, 0.25)"
                                }
                                onClick={() => {
                                  navigate("/notificaciones");
                                  closePopper();
                                }}
                              />
                            </div>
                          }
                        />
                      </ListItem>
                      <Divider />
                    </React.Fragment>
                  ))}
                </List>
              </Paper>
            </Fade>
          </ClickAwayListener>
        )}
      </Popper>
    </>
  );
}
